import type Channel from "../../models/Channel";
import { isUiModeDeveloper } from "../../uiMode";
import { itx } from "../../translationItx/itx";
import { isDevelopmentEnvironment } from "../../estada-config";
import Logger from "../../Logger";
import KnxDebugElement from "./KnxDebugElement";
import type KnxContext from "./KnxContext";

const logger = new Logger();

export default function KnxParameterSeparatror(props: {
  knxContext: KnxContext;
  currentTable: any;
  args?: any;
  params?: any;
  repeatindex?: number;
  channel?: Channel;
  moduleId: string;
  item: any;
  nestedName: string;
  nestedText: string;
  refId: string;
  instanceId: string;
  parentChannel: Channel;
}): any {
  const {
    knxContext,
    currentTable,
    args,
    params,
    repeatindex,
    moduleId,
    channel,
    item,
    nestedName,
    refId,
    instanceId,
  } = props;

  let iconElement: any = undefined;

  const icon = item.a.Icon;
  if (icon) {
    const filename = icon + ".png";
    const iconFileSrc = knxContext.knxProductData?.iconFileSrc[filename];
    console.log("iconFileSrc", filename, iconFileSrc);
    iconElement = <img className="knxIcon" src={iconFileSrc} alt="icon" />;
  }

  const debugElement = (
    <KnxDebugElement item={item} nestedName={nestedName} id={refId} instanceId={instanceId} knxContext={knxContext} />
  );

  let title0 = "";
  if (item.a.TextParameterRefId) {
    title0 = knxContext.getValue(item.a.TextParameterRefId, instanceId, true);
  }

  const text = knxContext.substitutePlaceholders({
    input: knxContext.getText(item),
    args,
    repeatindex,
    params,
    instanceId,
    moduleId,
    channel,
    title0,
  });

  // knxContext.knxInstanceData.addReEvalId(item.a.TextParameterRefId, instanceId);

  let element: any = undefined;

  if (item.a.UIHint === "HorizontalRuler") {
    element = (
      <div id={item.a.Id} className="knxParameterSeparator hr">
        {debugElement}
      </div>
    );
  } else if (item.a.UIHint === "Information") {
    element = (
      <div
        id={item.a.Id}
        className="knxParameterSeparator"
        style={{
          border: "1px solid blue",
          backgroundColor: "#e0e0ff",
        }}
      >
        <i className="las la-exclamation-circle" style={{ marginRight: "10px", fontSize: "1.5em" }}></i>
        {iconElement}
        <div>{text}</div>
        {debugElement}
      </div>
    );
  } else if (item.a.UIHint === "Error") {
    element = (
      <div
        id={item.a.Id}
        className="knxParameterSeparator"
        style={{
          border: "1px solid var(--error-color-dark)",
          backgroundColor: "var(--error-background)",
        }}
      >
        <i
          className="las la-times"
          style={{ marginRight: "10px", color: "var(--error-color-dark)", borderRadius: "10px" }}
        ></i>
        {iconElement}
        <div>{text}</div>
        {debugElement && <td>{debugElement}</td>}
      </div>
    );
  } else if (item.a.UIHint === "Headline") {
    element = (
      <div
        id={item.a.Id}
        className="knxParameterSeparator"
        style={{
          fontWeight: "bold",
        }}
      >
        {iconElement}
        <div>{text}</div>
        {debugElement}
      </div>
    );
  } else if (item.a.UIHint === "ParameterSeparator" || item.a.hasOwnProperty("Text")) {
    let txt = text.trim();
    if (isDevelopmentEnvironment() && txt == "" && item.a.Text && isUiModeDeveloper()) {
      txt = item.a.Text + itx("knxParameterViewer.transMissing", " (trans. missing)" + " " + item.a.refId); // no itx
    }
    if (txt) {
      element = (
        <div
          id={item.a.Id}
          className="ParameterSeparator"
          style={{
            fontWeight: "bold",
          }}
        >
          {iconElement}
          {txt}
          {debugElement}
        </div>
      );
    }
  } else {
    logger.error("unknown separator", item);
    return (
      <div id={item.a.Id} className="knxParameterSeparator">
        <div style={{ fontWeight: "bold", paddingLeft: "0px" }}>
          <hr />
        </div>
        {debugElement}
      </div>
    );
  }

  if (currentTable) {
    const cell = item.a.Cell;
    if (cell) {
      const ii = cell.split(",");
      if (!currentTable.cells[ii[0]]) {
        currentTable.cells[ii[0]] = [];
      }

      currentTable.cells[ii[0]][ii[1]] = element;
    }
    return undefined;
  }

  return element;
}
